import iamotaAjax from 'scripts/helpers/iamota-ajax';
var baseUrl = window.Shopify.routes.root;
var productRecommendations = {
  /**
   * Fetches product recommendations based on the provided product ID, limit, and intent.
   * @param {number} product_id - The ID of the product for which to fetch recommendations.
   * @param {number} [limit=10] - The maximum number of recommendations to fetch.
   * @param {string} [intent='related'] - The intent for fetching recommendations (e.g., 'related').
   * @returns {Promise} - The result of the AJAX get request.
   */
  fetch: function fetch(product_id) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var intent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'related';
    var queryData = {
      product_id,
      limit,
      intent
    };
    return iamotaAjax.get("".concat(baseUrl, "recommendations/products.json"), 'Shopify:productRecommendations', queryData);
  }
};
export default productRecommendations;